// extracted by mini-css-extract-plugin
export default {"wrapper":"provider_wrapper__42k9v"};